
<div *ngIf="loading" class="container d-flex align-items-center justify-content-center vh-100">
	<app-loading-spinner></app-loading-spinner>
</div>

<ng-container *ngIf="!loading">
	<div>
		<article class="headerLogo">
			<img class="headerLogoImg" src="{{ examinee.client?.image_logo ? examinee.client?.image_logo : logo }}" alt="header logo">
		</article>
	</div>
	<div *ngIf="questionnaire" class="page-content mt-5 p-0" [ngClass]="questionnaire.lang_code === 'he' ? 'rtl' : '' ">
		<ng-container *ngIf="!startQuestionnaire">
			<div class="container">
				<div class="card-header">
					<div class="progress progress-step-arrow progress-info rounded-0 rounded-top" [ngClass]="questionnaire.lang_code === 'he' ? 'progress-info-rtl' : '' ">
						<div class="progress-bar w-100" *ngFor="let step of steps; let i = index" [ngClass]="i === currentStep+1 ? 'next' : i > currentStep+1 ? 'bg-light text-body after' : ''">{{ 'ASSESSMENTAPP.' + step | translate : { Default: step } }}</div>
					</div>
				</div>
				<div class="card h-100 rounded-0 rounded-bottom">
					<div [ngSwitch]="currentStep" class="card-body">
						<div *ngSwitchCase="0">
							<app-assessment-guideness (nextButton)="settingsCheck($event)"></app-assessment-guideness>
						</div>
						<div *ngSwitchCase="1">
							<app-assessment-settings (nextButton)="settingsCheck($event)" [lang]="questionnaire.lang_code"></app-assessment-settings>
						</div>
						<div *ngSwitchCase="2">
							<app-assessment-description (nextButton)="settingsCheck($event)" [description]="questionnaire.description"></app-assessment-description>
						</div>
					</div>
					<div class="card-footer">
						<div class="row">
							<div *ngIf="currentStep > 0" class="me-auto col">
								<button class="btn btn-info btn-load" (click)="backStep()">{{ 'ASSESSMENTAPP.BACK' | translate }}</button>
							</div>
							<div [ngClass]="questionnaire.lang_code === 'he' ? 'text-start' : 'text-end' " class="col">
								<button class="btn btn-load" [ngClass]="currentStep === steps.length-1 ? 'btn-success' : 'btn-secondary'" (click)="nextStep()" [disabled]="!allowNext">
									<span class="d-flex justify-content-center">
										<span class="spinner-border" role="status" *ngIf="submitted && spinner">
											<span class="visually-hidden">Loading...</span>
										</span>
										<span [ngClass]="submitted && spinner ? 'ms-2' : ''">{{ currentStep === steps.length-1 ? ('ASSESSMENTAPP.START' | translate) : ('ASSESSMENTAPP.NEXT' | translate) }}</span>
									</span>
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</ng-container>
		<app-assessment-question *ngIf="startQuestionnaire"></app-assessment-question>
	</div>
</ng-container>